module.exports = __webpack_public_path__ + "img/ResultsTypes_Municipal_&_Industrial_Risks.5131d2c1.jpg";